import type { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { InputOptionType } from "src/types";
import { Icon, Icons } from "../Icon";
import { Flex } from "../Layouts/Flex";
import { Select } from "../Select";
import { Text } from "../Text";
import { buildPageSizeOptions, VALID_PAGE_SIZES } from "./tablePageSize";

const SELECT_OPTIONS: InputOptionType[] = buildPageSizeOptions(VALID_PAGE_SIZES);

export type TablePaginationProps = {
    nextPage: () => void;
    previousPage: () => void;
    setPageSize: (pageSize: number) => void;
    pageSize: number;
    pageIndex: number;
    totalPages: number;
};

export const TablePagination: FC<TablePaginationProps> = ({ previousPage, nextPage, pageIndex, pageSize, totalPages, setPageSize }) => {
    const { t } = useTranslation();
    const page = pageIndex + 1;

    return (
        <StyledContainer>
            <Flex justifyContent="end" alignItems="center">
                <Select
                    width="70px"
                    options={SELECT_OPTIONS}
                    value={pageSize?.toString()}
                    onChange={(value) => setPageSize(Number(value))}
                />
                <StyledPageWrapper>
                    <Flex alignItems="center" justifyContent="end">
                        <StyledIcon
                            icon={Icons.ArrowLeft}
                            disabled={pageIndex === 0}
                            onClick={previousPage}
                            height={26}
                            width={28}
                            alt={t("dashboard.previousWeek")}
                        />
                        <Text>{`${totalPages > 0 ? page : 0} ${t("from")} ${totalPages}`}</Text>
                        <Icon
                            icon={Icons.ArrowRight}
                            disabled={page === totalPages}
                            onClick={nextPage}
                            height={26}
                            width={28}
                            alt={t("dashboard.nextWeek")}
                        />
                    </Flex>
                </StyledPageWrapper>
            </Flex>
        </StyledContainer>
    );
};

const StyledContainer = styled.div`
    padding: 8px;
    border-color: ${({ theme }) => theme.color.gray100};
    border-width: 1px;
    border-top-style: solid;
`;

const StyledIcon = styled(Icon)`
    margin-top: 6px;
`;

const StyledPageWrapper = styled.div`
    width: 6.25rem;
`;
